import React from 'react';
import CountUp from 'react-countup';
import { motion } from 'framer-motion';
import { StatsContent } from '../../api/homepage';

const StatsBand = () => {
    return (
        <section className="bt-stats-section" aria-label="Bogin Tech key results and impact">
            <div className="bt-stats">
                <div className="bt-stats__head">
                    <motion.span
                        className="bt-stats__eyebrow"
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {StatsContent.eyebrow}
                    </motion.span>
                    <motion.h2
                        className="bt-stats__title"
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
                    >
                        {StatsContent.title}
                    </motion.h2>
                </div>

                <div className="bt-stats__grid">
                    {StatsContent.stats.map((stat, index) => (
                        <motion.div
                            className="bt-stat"
                            key={index}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.4 }}
                            transition={{ duration: 0.6, delay: 0.12 * index, ease: [0.22, 1, 0.36, 1] }}
                        >
                            <span className="bt-stat__num">
                                <CountUp
                                    end={stat.value}
                                    decimals={stat.decimals || 0}
                                    duration={2.4}
                                    enableScrollSpy
                                    scrollSpyOnce
                                />
                                <span className="bt-suffix">{stat.suffix}</span>
                            </span>
                            <span className="bt-stat__label">{stat.label}</span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsBand;
